export enum SkeletonShape {
	CHIP = 'chip',
	CIRCULAR = 'circular',
	COMPACT_TEXT = 'compact-text',
	DEFAULT = 'default',
	EXPANSIVE_TEXT = 'expansive-text',
	EXTRA_SMALL_TEXT = 'extra-small-text',
	LARGE_TEXT = 'large-text',
	LONG_TEXT = 'long-text',
	MEDIUM_TEXT = 'medium-text',
	PARENT = 'parent',
	RECTANGULAR = 'rectangular',
	SHORT_TEXT = 'short-text',
	SMALL_PARAGRAPH = 'small-paragraph',
	SMALL_TEXT = 'small-text',
	SPACIOUS_TEXT = 'spacious-text',
	WIDE_PARAGRAPH = 'wide-paragraph',
	WIDE_TEXT = 'wide-text',
}
